import React, { useEffect, useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import { Container, Typography, InputLabel, Paper, Divider, Button, Grid, FormControl, MenuItem, Select, FormHelperText, CircularProgress } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import EditIcon from '@material-ui/icons/Edit';
import CancelIcon from '@material-ui/icons/HighlightOff';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { MerchantActions, NotificationActions } from '../../../store';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
    },

    infoTitle: {
        "& h1": {
            float: 'left'
        },
        "& div": {
            width: '100px',
            display: 'block',
            margin: '0 0 5px auto'
        }
    },
    headerTitle: {
        fontWeight: 'bold',
        padding: '10px',
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const merchantsSelector = (state) => state.Merchants;
const IdentitySelector = (state) => state.Identity;

// 加盟店解約申請画面
const MerchantCancelletionApplying = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const merchantActions = bindActionCreators(MerchantActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(merchantsSelector);
    const { token } = useSelector(IdentitySelector);

    const { control, errors, handleSubmit, watch, register } = useForm();

    const { classes, data } = props;

    // 解約理由
    const [cancelReason, setCancelReason] = React.useState(null);

    // 確認ダイアログ表示フラグ
    const [dlgOpen, setDlgOpen] = React.useState(false);

    /**
     *
     * 戻るボタン押下時の処理
     *
     */
    const onBackClick = () => {
        props.onCancel();
    }

    /**
     *
     * 解約ボタン押下時の処理
     *
     */
    const onCancellationClick = () => {
        // 確認ダイアログを表示
        setDlgOpen(true);
    };

    /**
     *
     * 確認ダイアログでの「はい」ボタン押下時の処理（解約実行）
     *
     */
    const onDlgYesClick = () => {
        // 一旦、確認ダイアログを閉じる
        setDlgOpen(false);
        // 解約申請
        merchantActions.cancelletionApplying(token, editing, cancelReason)
            .then(data => {
                // 解約申請メッセージ表示
                notificationActions.showSuccess('解約申請しました。');
                // 加盟店プロフィール画面に遷移
                props.onCancel();
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     *
     * 確認ダイアログでの「いいえ」ボタン押下時の処理（キャンセル）
     *
     */
    const onDlgNoClick = () => {
        // 確認ダイアログを閉じる
        setDlgOpen(false);
    };

    /**
     *
     * 入力内容変更時の処理
     *
     */
    const onChange = (e) => {
        const { name, value } = e[0].target;

        if (name.startsWith('cancel_reason')) {
            setCancelReason(value);
        }

        return value;
    }

    const placeholder = <FormattedMessage id="Table.Action" />;

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <form className={classes.form} onSubmit={handleSubmit(onCancellationClick)} noValidate>
                    <Grid container className={classes.form} spacing={2} >
                        <Grid item xs={12}>
                            <Typography component="h1" variant="inherit">{<FormattedMessage id="Merchant.Cancellation" />}</Typography>
                            <Divider />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography component="h1" variant="inherit" align="center">{editing.merchant_name}</Typography>
                            <Divider />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography component="legend" className={classes.headerTitle}><FormattedMessage id={"Merchant.Cancelletion.Title1"} /></Typography>
                            <Typography component="legend" className={classes.headerTitle}><FormattedMessage id={"Merchant.Cancelletion.Title2"} /></Typography>
                            <Divider />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControl fullWidth required variant="outlined" error={errors.cancel_reason && true}>
                                <InputLabel id="merchant-label-cancel-reason"><FormattedMessage id={"Merchant.CancelReason"} /></InputLabel>
                                <Controller
                                    name="cancel_reason"
                                    control={control}
                                    onChange={onChange}
                                    rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                                    defaultValue={cancelReason}
                                    as={<Select
                                        labelId="merchant-label-cancel-reason"
                                        id="merchant-cancel-reason"
                                        label={<FormattedMessage id={"Merchant.CancelReason"} />}>
                                        <MenuItem value="1"><FormattedMessage id={"Merchant.CancelReason.1"} /></MenuItem>
                                        <MenuItem value="2"><FormattedMessage id={"Merchant.CancelReason.2"} /></MenuItem>
                                        <MenuItem value="3"><FormattedMessage id={"Merchant.CancelReason.3"} /></MenuItem>
                                        <MenuItem value="4"><FormattedMessage id={"Merchant.CancelReason.4"} /></MenuItem>
                                        <MenuItem value="5"><FormattedMessage id={"Merchant.CancelReason.5"} /></MenuItem>
                                        <MenuItem value="6"><FormattedMessage id={"Merchant.CancelReason.6"} /></MenuItem>
                                        <MenuItem value="7"><FormattedMessage id={"Merchant.CancelReason.7"} /></MenuItem>
                                        <MenuItem value="8"><FormattedMessage id={"Merchant.CancelReason.8"} /></MenuItem>
                                        <MenuItem value="9"><FormattedMessage id={"Merchant.CancelReason.9"} /></MenuItem>
                                        <MenuItem value="10"><FormattedMessage id={"Merchant.CancelReason.10"} /></MenuItem>
                                        <MenuItem value="11"><FormattedMessage id={"Merchant.CancelReason.11"} /></MenuItem>
                                        <MenuItem value="12"><FormattedMessage id={"Merchant.CancelReason.12"} /></MenuItem>
                                        <MenuItem value="13"><FormattedMessage id={"Merchant.CancelReason.13"} /></MenuItem>
                                        <MenuItem value="99"><FormattedMessage id={"Merchant.CancelReason.99"} /></MenuItem>
                                    </Select>} />
                                <FormHelperText>{errors.cancel_reason ? errors.cancel_reason.message : ""}</FormHelperText>
                            </FormControl>
                        </Grid>

                        <Grid container item xs={12} spacing={2} justify="center">
                            <Grid item xs={6}>
                                <Button fullWidth variant="contained" size="medium"
                                    startIcon={<ArrowBackIosIcon />}
                                    onClick={onBackClick}><FormattedMessage id="Button.Back" /></Button>
                            </Grid>
                            <Grid item xs={6}>
                                <Button fullWidth variant="contained" size="medium" color="secondary"
                                    onClick={handleSubmit(onCancellationClick)}
                                    startIcon={<CancelIcon />}><FormattedMessage id="Button.Cancellation" /></Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </Paper>

            <Dialog
                open={dlgOpen}
                onClose={onDlgNoClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"確認"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        解約を行いますか？
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onDlgYesClick} color="primary">
                        はい
                    </Button>
                    <Button onClick={onDlgNoClick} color="primary" autoFocus>
                        いいえ
                    </Button>
                </DialogActions>
            </Dialog>

            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(MerchantCancelletionApplying);
